// -----------------------------------------------------------------
// Path: src/app/app.routes.ts (NEW)
// -----------------------------------------------------------------
// This file defines the top-level routes for your application.

import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    // Lazy load the auth feature module (we will create this next)
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.AUTH_ROUTES)
  },
  {
    path: 'home',
    canActivate: [AuthGuard], // Protect this route
    // Lazy load the dashboard feature module
    loadChildren: () => import('./features/dashboard/dashboard.routes').then(m => m.DASHBOARD_ROUTES)
  },
  {
    path: '',
    redirectTo: '/home', // Default route
    pathMatch: 'full'
  },
  {
    path: 'session-expired',
    loadComponent: () => import('./features/auth/components/session-expired/session-expired.component').then(m => m.SessionExpiredComponent)
  },
  {
    path: '**',
    redirectTo: '/home' // Wildcard route
  }
];
